export default function(a, b) {
  return a - b;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-contour/src/ascending.js
// module id = 1010
// module chunks = 0